import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { FileDownloadResponse } from '@/repositories/generated';

const response: FileDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['端末ID', '外部端末ID', '端末種別', '端末名', 'OS種別', 'OSバージョン', 'デフォルト端末設定', '端末パスワード', '企業ID', '企業名', '店舗ID', '店舗名', 'QR法人ID', 'QRブランドID', 'QR契約店ID', 'QR端末/ステッカーID', 'ステータス', '利用開始日', '利用終了日', '登録日時', '更新日時', '備考'],
    ['0000000000BB8', '', '紙QR', 'iPhone6', 'iOS', '11.0', '', '1234', '00258', '企業00258', '00000258', '店舗00000258', 'dummyXXXXXXXX', 'X001', 'dummy1', 'dummy', '有効', '2023/12/01', '2100/12/31', '2023/12/01', '2023/12/01'],
  ]),
};

export const fileDownloadDownload = http.get(
  createMockEndpoint('/file_download/:id/download'),
  async ({ params }) => {
    if (params.id === '8') {
      return HttpResponse.json({ message: 'Internal Server Error' }, { status: 500 });
    }
    await delay(500);

    if (params.id === '13') {
      return HttpResponse.json({ message: 'Not Found' }, { status: 404 });
    }

    return HttpResponse.json(response, { status: 200 });
  },
);
